import Vue from 'vue';
import VueGtag from 'vue-gtag';
import router from '@/router';

// Vue Gtag Tracking
export const initGtag = async () => {
  try {
    const app = (await import('@/main')).default;
    const vm = app ? app() : null;

    if (
      vm?.$rsGlobals.$currentUser
        && !vm?.$rsGlobals.$currentUser.isSuperUser
        && !JSON.parse(window.localStorage.getItem('currentUserSettings') || '{}')?.impersonated
        && window.APP_CONFIG.VUE_APP_GTAG_ID
        && window.APP_CONFIG.VUE_APP_ENV === 'production'
    ) {
      // eslint-disable-next-line no-console
      console.log('gtag init');
      Vue.use(VueGtag, {
        config: {
          id: `${window.APP_CONFIG?.VUE_APP_GTAG_ID}`,
        }, // Google Site Tag ID
      }, router);
    }
  } catch (err) {
    console.warn(err);
  }
};
